import { render, staticRenderFns } from "./workshop.vue?vue&type=template&id=7c1ac60b&scoped=true&"
import script from "./workshop.vue?vue&type=script&lang=js&"
export * from "./workshop.vue?vue&type=script&lang=js&"
import style0 from "./workshop.vue?vue&type=style&index=0&id=7c1ac60b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1ac60b",
  null
  
)

export default component.exports